var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{class:`hint is-${_vm.type}`},[_c('span',{staticClass:"icon"},[_c('i',{class:[
        'fa-sharp',
        'fa-regular',
        {
          'fa-triangle-exclamation': _vm.type === 'warning',
          'fa-circle-info': _vm.type === 'info',
          'fa-circle-minus': _vm.type === 'danger',
        }
      ]})]),_c('div',{staticClass:"hint-body"},[(_vm.title)?_c('h4',{staticClass:"title is-4"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_c('span',{staticClass:"has-text-body"},[_vm._t("default")],2),(_vm.$slots.actions)?_c('span',{staticClass:"button-hint"},[_vm._t("actions")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }